import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import ImageWithBasePath from "../../core/common/imageWithBasePath";
import { all_routes } from "../router/all_routes";
import { loginUser } from "../../api/authService";
import { jwtDecode, JwtPayload } from "jwt-decode";
import { useDispatch } from "react-redux";
import { login } from "../../core/data/redux/authSlice";
import { toast } from "react-toastify";
import { startAutoLockWatcher } from "../../api/autolock";

type CustomJwtPayload = JwtPayload & {
  role?: string;
  id?: string;
  client_id?: string;
  username?: string;
};
// Validation schema
const validationSchema = Yup.object().shape({
  email: Yup.string()
    .email("Invalid email format")
    .required("Email is required"),
  password: Yup.string()
    .min(8, "Password must be at least 8 characters")
    .matches(/[A-Z]/, "Must contain at least one uppercase letter")
    .matches(/[a-z]/, "Must contain at least one lowercase letter")
    .matches(/\d/, "Must contain at least one number")
    .matches(
      /[@$!%*?&]/,
      "Must contain at least one special character (@$!%*?&)"
    )
    .required("Password is required"),
});
const slides = [
  //{ img: "/assets/img/background.jpg", text: "Track Leads Faster" },
  { img: "/assets/img/background2.jpeg", text: "Sales Pipeline" },
  //{ img: "/assets/img/loginpage3.png", text: "Workflow Automation" },
  //{ img: "/assets/img/loginpage4.png", text: "Multi-User CRM" },
  //{ img: "/assets/img/loginpage5.png", text: "Analytics & Reporting" },
  { img: "/assets/img/authentication/email-img.png", text: "Analytics & Reporting" },
  { img: "/assets/img/authentication/login-img.png", text: "Analytics & Reporting" },
  { img: "/assets/img/authentication/register-img.png", text: "Analytics & Reporting" },
  { img: "/assets/img/authentication/success-img.png", text: "Analytics & Reporting" },
  { img: "/assets/img/authentication/verify-img.png", text: "Analytics & Reporting" },
];

const LeftImage = () => {
  const [randomImage, setRandomImage] = useState(slides[0].img);

  useEffect(() => {
    const rand = Math.floor(Math.random() * slides.length);
    setRandomImage(slides[rand].img);
  }, []);

  return <img src={randomImage} alt="Login Visual" />;
};

const Login: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isPasswordVisible, setPasswordVisible] = useState(false);
  useEffect(() => {
    const token = localStorage.getItem("authToken");
    const role = localStorage.getItem("userRole");

    if (window.location.pathname === "/login" && token && role) {
      if (role === "superadmin") navigate(all_routes.superadminDashboard);
      else if (role === "admin") navigate(all_routes.dealsDashboard);
      else navigate(all_routes.leadsDashboard);
    }
  }, [navigate]);
    useEffect(() => {
    const styleId = "animated-badge-keyframes";
    if (!document.getElementById(styleId)) {
      const styleSheet = document.createElement("style");
      styleSheet.id = styleId;
      styleSheet.innerText = `
        @keyframes shine {
          0% {
            transform: skewX(-20deg) translateX(-150%);
          }
          50% {
             transform: skewX(-20deg) translateX(150%);
          }
          100% {
            transform: skewX(-20deg) translateX(150%);
          }
        }
      `;
      document.head.appendChild(styleSheet);
    }
  }, []);

  const handleLogin = async (values: {
    email: string;
    password: string;
    rememberMe: boolean;
  }) => {
    try {
      const data = await loginUser(
        values.email,
        values.password,
        values.rememberMe
      );

      if (data.access_token) {
        const fullToken = `${data.token_type} ${data.access_token}`;
        localStorage.setItem("authToken", fullToken);

       const decodedToken = jwtDecode<CustomJwtPayload>(data.access_token);

let expiryTimeMs: number | undefined;

if (typeof decodedToken.exp === "number") {
  expiryTimeMs = decodedToken.exp * 1000;

  localStorage.setItem("token_expiry", expiryTimeMs.toString());

  // 🧪 Debug log (login time)
  const now = Date.now();
  const diffMs = expiryTimeMs - now;

  const minutes = Math.floor(diffMs / 60000);
  const seconds = Math.floor((diffMs % 60000) / 1000);

  console.log(
    `[LOGIN] Token expires in ${minutes}m ${seconds}s`,
    {
      exp: decodedToken.exp,
      expiryTimeMs,
      now,
    }
  );
} else {
  console.warn("[LOGIN] Token has no exp claim");
}


const userRole = decodedToken.role ?? "user";
        const clientId = decodedToken.client_id ?? "";
        const userId = decodedToken.id ?? "";
        const username = decodedToken.username ?? "";

        localStorage.setItem("userRole", userRole);
        localStorage.setItem("clientId", clientId);
        localStorage.setItem("user_id", userId);
        localStorage.setItem("username", username);
        localStorage.setItem("email", values.email);
        dispatch(
          login({
            token: fullToken,
            role: userRole,
            client_id: clientId,
            user_id: userId,
            username: username,
            e_mail: values.email,
          })
        );
        toast.success("Login successfully");
        if (userRole === "superadmin") navigate(all_routes.superadminDashboard);
        else if (userRole === "admin") navigate(all_routes.dealsDashboard);
        else navigate(all_routes.leadsDashboard);
           startAutoLockWatcher(navigate);
      } else {
        toast.error("Invalid credentials");
      }
    } catch (error) {
      toast.error("Login failed. Please try again.");
    }
  };

  return (
    <div className="login-page-container">
      {/* LEFT PANEL IMAGE */}
      <div className="login-left-image">   <LeftImage /></div>

      {/* RIGHT PANEL LOGIN CARD */}
      <div className="login-right-card">
        <div
          className="login-wrapper"
          style={{
            display: "flex",
            flexDirection: "column",
            maxWidth: "420px",
            width: "100%",
            backgroundColor: "#ffffff",
           // in inline style of login-wrapper
borderRadius: "18px",
boxShadow: "0 18px 45px rgba(15, 23, 42, 0.12)",
padding: "28px 32px",

            animation: "fadeIn 1s ease-in-out",
          }}
        >
          {/* Left Login Form Section */}
          <div style={{ flex: 1, padding: "15px" }}>
            {" "}
            {/* Reduced padding from 20px */}
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                marginBottom: "15px",
              }}
            >
              {" "}
              {/* Reduced margin from 20px */}
              <ImageWithBasePath
                src="assets/img/logo.png"
                className="img-fluid"
                alt="Logo"
                style={{
                  width: "130px", // Increase from 100px to 130px
                  maxWidth: "100%",
                  height: "auto",
                }}
              />
            </div>
            <h2 className="text-center fw-bold" style={{ color: "#007BFF" }}>
              Login to CRMS
            </h2>
            <p className="text-center mb-4" style={{ color: "#555" }}>
              Welcome back! Please sign in
            </p>
            {/* Reduced margin from 20px */}
            <Formik
              initialValues={{ email: "", password: "", rememberMe: false }}
              validationSchema={validationSchema}
              onSubmit={handleLogin}
            >
              {({ isSubmitting }) => (
                <Form>
                  <div className="mb-3">
                    <label htmlFor="email" className="form-label">
                      Email Address<span className="ms-1 text-danger">*</span>
                    </label>
                    <div className="input-with-icon">
                      <i className="bi bi-envelope"></i>
                      <Field
                        id="email"
                        type="email"
                        name="email"
                        className="form-control"
                        aria-required="true"
                        aria-describedby="emailHelp"
                        style={{
                          padding: "8px",
                          borderRadius: "4px",
                          border: "1px solid #ccc",
                        }} // Reduced padding from 10px
                      />
                    </div>
                    <ErrorMessage
                      name="email"
                      component="div"
                      className="text-danger small mt-1"
                    />
                  </div>
                  <div className="mb-3">
                    <label htmlFor="password" className="form-label">
                      Password<span className="ms-1 text-danger">*</span>
                    </label>
                    <div className="pass-group position-relative">
                      <div className="input-with-icon">
                        <i className="bi bi-lock"></i>

                        <Field
                          id="password"
                          type={isPasswordVisible ? "text" : "password"}
                          name="password"
                          className="form-control"
                          style={{
                            padding: "8px",
                            borderRadius: "4px",
                            border: "1px solid #ccc",
                          }} // Reduced padding from 10px
                        />
                        <span
                          data-testid="toggle-password"
                          onClick={() => setPasswordVisible((prev) => !prev)}
                          className={`ti toggle-password ${
                            isPasswordVisible ? "ti-eye" : "ti-eye-off"
                          }`}
                          style={{
                            position: "absolute",
                            right: "10px",
                            top: "50%",
                            transform: "translateY(-50%)",
                            cursor: "pointer",
                          }}
                        />
                      </div>
                    </div>
                    <ErrorMessage
                      name="password"
                      component="div"
                      className="text-danger small mt-1"
                    />
                  </div>
                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <div className="form-check">
                      <Field
                        type="checkbox"
                        name="rememberMe"
                        className="form-check-input"
                      />
                      <label className="form-check-label">Remember Me</label>
                    </div>
                    <Link
                      to={all_routes.forgotPassword}
                      className="text-primary fw-medium"
                    >
                      Forgot Password?
                    </Link>
                  </div>
                  <button
                    type="submit"
                    className="btn  w-100 d-flex align-items-center justify-content-center gap-2"
                    disabled={isSubmitting}
                    style={{
                        position: "relative",        // ✅ IMPORTANT
    overflow: "hidden", 
                      background: "#007BFF",
                      color: "#fff",
                      padding: "8px", // Reduced from 10px
                      borderRadius: "4px",
                      transition: "all 0.3s ease",
                      fontWeight: "bold",
                    }}
                  >
                    
                    {isSubmitting && (
                      <span
                        className="spinner-border spinner-border-sm"
                        role="status"
                        aria-hidden="true"
                      ></span>
                      
                    )}
                    <span style={{ position: "relative", zIndex: 2 }}>
                {isSubmitting ? "Signing In..." : "Next"}
              </span>
               <span
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  background:
                    "linear-gradient(to right, transparent 0%, rgba(255, 255, 255, 0.4) 50%, transparent 100%)",
                  transform: "skewX(-20deg) translateX(-150%)",
                  animation: "shine 3s infinite",
                }}
              />
                   
                  </button>
                  <div
                    style={{
                      textAlign: "center",
                      marginTop: "15px",
                      marginBottom: "15px",
                    }}
                  >
                    <div className="login-divider">or</div>
                  </div>{" "}
                  {/* Reduced margins from 20px */}
                  <p style={{ textAlign: "center", color: "#666" }}>
                    <span>Don't have an account? </span>
                    <a
                      href="https://www.royaltechsystems.co.in/"
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{
                        color: "#007BFF",
                        fontWeight: 600,
                        cursor: "pointer",
                      }}
                    >
                      Contact Us
                    </a>
                  </p>
                </Form>
              )}
            </Formik>
          </div>

          {/* Right Info Section */}
        </div>
      </div>

      {/* Fade/Slide Animations */}
      <style>{`
/* Logo resize on medium+ screens */
@media (min-width: 768px) {
  .login-wrapper img {
    width: 150px !important;
  }
}

/* Animations */
@keyframes fadeIn {
  0% { opacity: 0; transform: scale(0.95); }
  100% { opacity: 1; transform: scale(1); }
}

@keyframes slideDown {
  0% { opacity: 0; transform: translateY(-20px); }
  100% { opacity: 1; transform: translateY(0); }
}

/* PAGE LAYOUT – TWO COLUMN SPLIT */
.login-page-container {
  display: flex;
  height: 100vh;
  width: 100%;
  overflow: hidden;
}

/* LEFT SIDE – FULLY RESPONSIVE, NO CROPPING */
.login-left-image {
  flex: 1;
  background-color: #f3f3f3;
  display: flex;
  align-items: center;
  justify-content: center;
}

.login-left-image img {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}

.login-right-card {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px;

  /* Soft pastel BLUE gradient background */
  background: linear-gradient(135deg, #e8f3ff 0%, #f3f9ff 50%, #d8eaff 100%);

  /* Soft blue glow inner shadow */
  box-shadow: inset 0px 0px 120px rgba(50, 120, 255, 0.25);

  transition: background 0.3s ease, box-shadow 0.3s ease;
}


/* LARGE SCREEN – give more space to image */
@media (min-width: 1200px) {
  .login-left-image {
    flex: 1.3;
  }
}

/* TABLET – reduce image area */
@media (max-width: 992px) {
  .login-left-image {
    flex: 0.8;
  }
}

/* MOBILE – hide left image */
@media (max-width: 768px) {
  .login-left-image {
    display: none;
  }
  .login-right-card {
    flex: 1;
    padding: 20px;
  }
}

  .input-with-icon {
  position: relative;
}

.input-with-icon i {
  position: absolute;
  top: 50%;
  left: 12px;
  transform: translateY(-50%);
  font-size: 18px;
 
  opacity: 0.8;
}

.input-with-icon .form-control {
  padding-left: 40px !important;
  height: 45px;
  border-radius: 8px;
}
  .input-with-icon .form-control:focus {
  border-color: #007bff;
  box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.18);
  outline: none;
}
  
/* =============================
   Divider Line Style
============================= */
.login-divider {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #777;
  margin: 20px 0;
  position: relative;
  font-size: 13px;
}

.login-divider::before,
.login-divider::after {
  content: "";
  flex: 1;
  height: 1px;
  background: #ddd;
  margin: 0 10px;
}

`}</style>
    </div>
  );
};

export default Login;

// <div style={{ flex: 1, padding: "15px", background: "#F0F4F8", borderRadius: "0 10px 10px 0" }}> {/* Reduced padding and adjusted borderRadius */}
//         <h3 style={{ color: "#2C3E50", marginBottom: "15px" }}>Passwordless Sign-in</h3> {/* Reduced margin from 20px */}
//         <p style={{ color: "#666", marginBottom: "15px" }}>
//           Move away from risky passwords and experience one-tap access to CRMS. Download and install OneAuth.
//         </p>
//         <button
//           style={{
//             background: "#E0EAFB",
//             color: "#007BFF",
//             padding: "8px", // Reduced from 10px
//             borderRadius: "20px",
//             border: "none",
//             display: "block",
//             margin: "0 auto",
//           }}
//         >
//           Learn more
//         </button>

//         <div style={{ marginTop: "15px" }}> {/* Reduced from 20px */}
//           <h3 style={{ color: "#2C3E50", marginBottom: "15px" }}>Start your free trial</h3> {/* Reduced margin from 20px */}
//           <p style={{ color: "#666", marginBottom: "15px" }}>
//             No credit card required, no software to install. With your trial, you get:
//           </p>
//           <ul style={{ color: "#666", paddingLeft: "15px" }}> {/* Reduced padding from 20px */}
//             <li>Preloaded data or upload your own</li>
//             <li>Preconfigured processes, reports, and dashboards</li>
//             <li>Guided experiences for sales reps, leaders, and administrators</li>
//             <li>Online training and live onboarding webinars</li>
//           </ul>
//           <button
//             style={{
//               background: "#007BFF",
//               color: "#fff",
//               padding: "8px", // Reduced from 10px
//               borderRadius: "4px",
//               border: "none",
//               display: "block",
//               margin: "15px 0", // Reduced from 20px
//               width: "100%",
//             }}
//           >
//             Start my free trial
//           </button>
//         </div>

//         <div style={{ marginTop: "15px" }}> {/* Reduced from 20px */}
//           <h3 style={{ color: "#E67E22", marginBottom: "15px" }}>What's New</h3> {/* Reduced margin from 20px */}
//           <p style={{ color: "#666" }}>
//             Section Dividers for Custom Fields. Keep your CRM tidy with section dividers for Contacts, Organizations, and Deals.
//           </p>
//           <p style={{ color: "#666", fontSize: "12px" }}>
//             <a href="#" style={{ color: "#007BFF" }}>Read more</a>
//           </p>
//         </div>
//       </div>
